import { semanticColor, TextList, TextListGroup } from '@repo/ui';
import { FC } from 'react';

interface Item {
  content: string;
}

interface Props {
  data: Item[];
}
type ApplyResultInfoViewProps = Props;

const ApplyResultInfoView: FC<ApplyResultInfoViewProps> = ({ data }) => {
  return (
    <TextListGroup className={'pb-normal-large'}>
      {data.map((item, index) => {
        return (
          <TextList
            variant={'bullet'}
            bulletColor={semanticColor.neutral.foreground.lowest}
            className={'text-neutral-foreground-low'}
            size={'large'}
            key={index}
          >
            {item.content}
          </TextList>
        );
      })}
    </TextListGroup>
  );
};

export default ApplyResultInfoView;
